const translations = {
  login: 'Đăng nhập',
  logOut: 'Thoát',
  email: 'Email',
  password: 'Mật khẩu',
  code: 'Mã xác thực'
};

export default translations;
